import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {ProductLineEditPageComponent} from "../../product-line/product-line-edit-page/product-line-edit-page.component"
import {PlgEditPageComponent} from "../../plg/plg-edit-page/plg-edit-page.component"
import {AbstractColumnComponent} from "../../../framework/entity/grid/abstract-column.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-composite-product-component-edit-link-column",
    templateUrl: "./composite-product-component-edit-link-column.component.html",
    styleUrls: ["./composite-product-component-edit-link-column.component.scss"],
    providers: [
        {
            provide: ColumnComponent,
            useExisting: forwardRef(() => CompositeProductComponentEditLinkColumnComponent),
            multi: true
        }
    ]
})
export class CompositeProductComponentEditLinkColumnComponent extends AbstractColumnComponent {
    @Input() discontinuedLabel: string = "wbo.common.label.discontinued";
    @Input() unavailableLabel: string = "wbo.common.label.unavailable";

    ProductLineEditPageComponent = ProductLineEditPageComponent;
    PlgEditPageComponent = PlgEditPageComponent;
    EditMode = EditMode;

    constructor(injector: Injector) {
        super(injector);
        this.linkable = true;
        this.field = "name";
    }
}
